import type { CoverLetterDto, DeleteCoverLetterDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";

export const deleteCoverLetter = async (data: DeleteCoverLetterDto) => {
  const response = await axios.delete<
    CoverLetterDto,
    AxiosResponse<CoverLetterDto>,
    DeleteCoverLetterDto
  >(`/cover-letter/${data.id}`);

  return response.data;
};

export const useDeleteCoverLetter = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: deleteCoverLetterFn,
  } = useMutation({
    mutationFn: deleteCoverLetter,
    onSuccess: (data) => {
      queryClient.removeQueries({ queryKey: ["cover-letter", data.id] });

      queryClient.setQueryData<CoverLetterDto[]>(["cover-letters"], (cache) => {
        if (!cache) return [];
        return cache.filter((cl) => cl.id !== data.id);
      });
    },
  });

  return { deleteCoverLetter: deleteCoverLetterFn, loading, error };
};
